import axios from "axios";

export const APIURL = () => {
  //  return "https://thingproxy.freeboard.io/fetch/http://139.59.28.82/vtc/api/";
  // return "https://cors-anywhere.herokuapp.com/http://139.59.28.82/vtc/api/";
  return "https://virtualtourcafe.com/admin/api/";
}
export const HomePageUrl = () => {
  //  return "/";
   return "https://virtualtourcafe.com/";
}
export const MlsPath = () => {
  //  return "/";
   return "/mls/";
}
export const StrictPath = () => {
  //  return "/";
   return "/strict/";
}
export const APIPath = () => {
  //  return "/";
   return "/tour/";
}
export const fetchAllRecords = (url, ctoken) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, ctoken)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        if (axios.isCancel(err)) {
        } else {
          reject(err);
        }
      });
  });
};
export const fetchRecordByID = (url, id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url + id)
      .then(res => {
        resolve(res);
      })
      .catch(err => reject(err));
  });
};
